import {
  MarketplaceListingDetailQuery,
  MarketplaceListingDetailQueryVariables
} from './__generated__/MarketplaceListingDetailQuery'
import {
  MarketplaceListingCadencePolicyQueryV2,
  MarketplaceListingCadencePolicyQueryV2Variables
} from './__generated__/MarketplaceListingCadencePolicyQueryV2'
import {
  MarketplaceListingPropsQueryV2,
  MarketplaceListingPropsQueryV2Variables
} from './__generated__/MarketplaceListingPropsQueryV2'
import { ComputedDateCatalogQuery } from './__generated__/ComputedDateCatalogQuery'

import { gql } from 'apollo-boost'
import { useQuery } from '@apollo/react-hooks'

const QUERY = gql`
  query MarketplaceListingDetailQuery($id: String!) {
    installableCategories {
      id
      created
      title
    }
    marketplaceListingFeatureTypes(input: { includeDynamic: false }) {
      id
      title
    }
    languages {
      id
      language
    }
    publicInstallables {
      id
      created
      title
      description
      icon
      configurationSchema
    }
    marketplaceListing(id: $id) {
      id
      releaseDate
      icon
      free
      hiddenFromProduction
      featureTypes {
        id
        marketplaceListingFeatureType {
          id
        }
      }
      iconMedia {
        id
      }
      carouselMedia1Ref {
        id
      }
      carouselMedia2Ref {
        id
      }
      carouselMedia3Ref {
        id
      }
      isFeatured
      categories {
        id
        title
      }
      configuration
      carouselMedia1
      carouselMedia2
      carouselMedia3
      noteCarouselMedia1
      noteCarouselMedia2
      noteCarouselMedia3
      noteCarouselMedia1Ref {
        id
      }
      noteCarouselMedia2Ref {
        id
      }
      noteCarouselMedia3Ref {
        id
      }
      language {
        id
        language
      }
      version
      installable {
        id
        title
        created
        description
        icon
        hideFromInstallablesList
        installationsAreSingleton
        configurationSchema
        subscriptionsCanBeRenamed
        developer {
          id
          title
        }
      }
      messageSetId
      noteMessageSetId
      creator {
        id
        title
      }
      title
      description
      stagingOnly
      shortDescription
      questionAndAnswerId
      noteQuestionAndAnswerId
      tags
      supportsNote
      supportsFlagship
      previewMessage
      notePreviewMessage
      readyForReactNative
    }
  }
`

const PROPS_QUERY = gql`
  query MarketplaceListingPropsQueryV2($marketplaceListingId: String!) {
    marketplaceListingPropsV2(marketplaceListingId: $marketplaceListingId) {
      ... on MarketplaceListingPropsV2 {
        marketplaceListingId
        propsJson
      }
      ... on MarketplaceListingErrorV2 {
        type
        error
      }
    }
  }
`

const CADENCE_POLICY_QUERY = gql`
  query MarketplaceListingCadencePolicyQueryV2($marketplaceListingId: String!) {
    marketplaceListingCadencePolicyV2(marketplaceListingId: $marketplaceListingId) {
      ... on MarketplaceListingCadencePolicyV2 {
        marketplaceListingId
        policyJson
      }
      ... on MarketplaceListingErrorV2 {
        type
        error
      }
    }
  }
`

const COMPUTED_DATE_CATALOG_QUERY = gql`
  query ComputedDateCatalogQuery {
    computedDateCatalog {
      slug
      label
    }
  }
`

export const useGetMarketplaceListing = (variables: MarketplaceListingDetailQueryVariables) =>
  useQuery<MarketplaceListingDetailQuery, MarketplaceListingDetailQueryVariables>(QUERY, {
    variables
  })

export const useGetMarketplaceListingProps = (variables: MarketplaceListingPropsQueryV2Variables) =>
  useQuery<MarketplaceListingPropsQueryV2, MarketplaceListingPropsQueryV2Variables>(PROPS_QUERY, {
    variables
  })

export const useGetMarketplaceListingCadencePolicy = (
  variables: MarketplaceListingCadencePolicyQueryV2Variables
) =>
  useQuery<MarketplaceListingCadencePolicyQueryV2, MarketplaceListingCadencePolicyQueryV2Variables>(
    CADENCE_POLICY_QUERY,
    {
      variables
    }
  )

export const useComputedDateCatalog = () =>
  useQuery<ComputedDateCatalogQuery>(COMPUTED_DATE_CATALOG_QUERY)
